module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "Post"
  }, [_c('a', {
    attrs: {
      "href": _vm.post.link
    }
  }, [_c('div', {
    staticClass: "Thumbnail"
  }, [_c('img', {
    attrs: {
      "src": _vm.getThumbnail,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Text"
  }, [_c('p', [_vm._v(_vm._s(_vm.date))]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.post.title.rendered))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3e474423!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Post.vue
// module id = 381
// module chunks = 2